const alertTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export default alertTypes;
